import { useStarPerformers } from "../hooks/useStarPerformers";
import React from "react";
import * as Icon from "lucide-react";

const StarPerformers = () => {
	const { data, isLoading } = useStarPerformers();
	const title = data?.title || "⭐ Star Performers";
	const subtitle = data?.subtitle || "Our Pride";
	const performers = data?.performers || [];
	if (isLoading) {
		return (
			<section className="py-24 px-4 bg-maroon-gradient" id="star-performers">
				<div className="max-w-6xl mx-auto text-cream">Loading star performers...</div>
			</section>
		);
	}
	return (
		<section className="py-24 px-4 bg-maroon-gradient" id="star-performers">
		<div className="max-w-6xl mx-auto">
			<div className="text-center mb-16">
			<p className="text-gold-light font-heading text-lg tracking-widest uppercase mb-2">
				{subtitle}
			</p>
			<h2 className="text-4xl md:text-5xl font-display font-bold text-gold-gradient mb-4">
				{title}
			</h2>
			<div className="w-24 h-1 bg-accent mx-auto rounded-full" />
			</div>
			{
				performers.length === 0 ? (
					<p className="text-center text-cream/80 font-body">
						No star performers added yet.
					</p>
				):(

					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
						{performers.map((dancer) => {
							const IconComponent = Icon[dancer.icon] || Icon.Trophy;
							return (
								<div
									key={dancer.name}
									className="group relative p-6 rounded-xl bg-cream/5 border border-gold/20 hover:border-gold/50 transition-all duration-300 hover:-translate-y-1"
								>
									<div className="w-20 h-20 mx-auto mb-4 rounded-full bg-accent/20 border-2 border-gold/40 flex items-center justify-center group-hover:shadow-gold transition-shadow duration-300">
										{
											IconComponent && React.createElement(IconComponent, { className: "w-10 h-10 text-gold" })
										}
									</div>

									<h3 className="text-center font-display text-xl font-bold text-gold-gradient mb-1">
										{dancer.name}
									</h3>
									<p className="text-center text-gold-light/80 font-heading text-sm tracking-wider uppercase mb-3">
										{dancer.course}
									</p>
									<div className="text-center">
										<span className="inline-block px-3 py-1 rounded-full bg-accent/15 border border-gold/20 text-cream/90 text-xs font-body">
										🏆 {dancer.achievements}
										</span>
									</div>
								</div>
							);
						})}
					</div>
				)
			}
		</div>
		</section>
	);
};

export default StarPerformers;
/*  
import * as Icon from "lucide-react";
import { useStarPerformers } from "../hooks/useStarPerformers";
import React from "react";


const StarPerformers = () => {
	const { data, isLoading } = useStarPerformers();
	const title = data?.title || "Star Performers";
	const subtitle = data?.subtitle || "Our Pride";
	const performers = data?.performers || [];
	if (isLoading) {
		return (
			<section className="py-24 px-4 bg-maroon-gradient" id="star-performers">
				<div className="max-w-6xl mx-auto text-cream">Loading star performers...</div>
			</section>
		);
	}
	return (
		<section className="py-24 px-4 bg-maroon-gradient" id="star-performers">
			<div className="max-w-6xl mx-auto">
				<div className="text-center mb-16">
					<p className="text-gold-light font-heading text-lg tracking-widest uppercase mb-2">
						{subtitle}
					</p>
					<h2 className="text-4xl md:text-5xl font-display font-bold text-gold-gradient mb-4">
						{title}
					</h2>
					<div className="w-24 h-1 bg-accent mx-auto rounded-full" />
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
				{performers.length === 0 ? (
					<p className="text-center text-cream/80 font-body">
						No star performers added yet.
					</p>
					) : (
						<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
							{performers.map((dancer) => {
								const IconComponent = Icon[dancer.icon] || Icon.Trophy;
								return (
									<div
										key={dancer.name}
										className="group relative p-6 rounded-xl bg-cream/5 border border-gold/20 hover:border-gold/50 transition-all duration-300 hover:-translate-y-1"
									>
										<div className="w-20 h-20 mx-auto mb-4 rounded-full bg-accent/20 border-2 border-gold/40 flex items-center justify-center group-hover:shadow-gold transition-shadow duration-300">
											{
												IconComponent && React.createElement(IconComponent, { className: "w-10 h-10 text-gold" })
											}
										</div>

										<h3 className="text-center font-display text-xl font-bold text-gold-gradient mb-1">
											{dancer.name}
										</h3>
										<p className="text-center text-gold-light/80 font-heading text-sm tracking-wider uppercase mb-3">
											{dancer.course}
										</p>
										<div className="text-center">
											<span className="inline-block px-3 py-1 rounded-full bg-accent/15 border border-gold/20 text-cream/90 text-xs font-body">
											🏆 {dancer.achievements}
											</span>
										</div>
									</div>
								);
							})}
						</div>
					)}
				</div>
			</div>
		</section>
	);
};

export default StarPerformers;


*/